import React from "react";
import { shape, string } from "prop-types";
import { mergeClasses } from "../../classify";
import SearchField from "./searchField";
import defaultClasses from "./searchBar.css";
var SearchBar = props => {
  var {
    styles = {},
    outWrapperRef
  } = props;
  var classes = mergeClasses(defaultClasses, props.classes);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    style: styles
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.search
  }, /*#__PURE__*/React.createElement(SearchField, {
    outWrapperRef: outWrapperRef
  })))));
};
export default SearchBar;
SearchBar.propTypes = {
  classes: shape({
    container: string,
    form: string,
    root: string,
    root_open: string,
    search: string
  })
};